import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d7c83e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-courses" }
const _hoisted_2 = { class: "profile__course-filter" }
const _hoisted_3 = { class: "filter__search" }
const _hoisted_4 = { class: "filter__select" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "profile__label",
  for: "filter_by"
}, "Filtrar por:", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "all" }, "Todos", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "online-finished" }, "Treinamento online finalizados", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "online-in-progress" }, "Treinamento online em andamento", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "face" }, "Treinamento presencial", -1))
const _hoisted_11 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "message-box"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "message" }, "Nenhum resultado encontrado para sua pesquisa.", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  class: "message-box"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "message" }, " Você ainda não concluiu nenhum treinamento. ", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 3,
  class: "message-box"
}
const _hoisted_21 = { class: "message" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Você não tem nenhum treinamento em andamento, acesse o ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" dashboard ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" para explorar os treinamentos e trilhas de estudo. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_LineOnlineTraining = _resolveComponent("LineOnlineTraining")!
  const _component_LineFaceTraining = _resolveComponent("LineFaceTraining")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Search, {
          onSearching: _cache[0] || (_cache[0] = ($event: any) => ($setup.search(_ctx.$router, $event))),
          "search-bar-text": "Pesquisar nome...",
          height: '24px',
          fontSize: '15px',
          id: "search-courses"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("select", {
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.sortTrainingTypes && $setup.sortTrainingTypes(...args))),
          name: "filter_by",
          id: "filter_by",
          value: $setup.route.query.filter || 'all',
          class: "form-control"
        }, _hoisted_11, 40, _hoisted_6)
      ])
    ]),
    ($setup.trainings.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.trainings, (training, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(['course', { disable: $setup.isInactive(training) }]),
              key: index,
              onClick: ($event: any) => ($setup.redirectToTraining(training))
            }, [
              (training.type === $setup.EnrolledTrainingTypes.ONLINE)
                ? (_openBlock(), _createBlock(_component_LineOnlineTraining, {
                    key: 0,
                    training: training
                  }, null, 8, ["training"]))
                : _createCommentVNode("", true),
              (training.type === $setup.EnrolledTrainingTypes.FACE)
                ? (_openBlock(), _createBlock(_component_LineFaceTraining, {
                    key: 1,
                    training: training
                  }, null, 8, ["training"]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_13))
          }), 128))
        ]))
      : (_ctx.$route.query.search)
        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_16))
        : (_ctx.$route.query.filter === 'finished')
          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _hoisted_19))
          : (_openBlock(), _createElementBlock("span", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_router_link, {
                  class: "highlighted-text",
                  to: { name: 'dashboard' }
                }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 1
                }),
                _hoisted_24
              ])
            ]))
  ]))
}